import React from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import styles from './NotFound.module.css';

/**
 * A reusable 404 Not Found component
 * @param {Object} props
 * @param {string} props.title - Custom title for the page
 * @param {string} props.heading - Custom heading text
 * @param {string} props.message - Custom message text
 * @param {boolean} props.showHomeButton - Whether to show a home button
 * @param {string} props.homeButtonText - Custom text for home button
 * @param {string} props.homeButtonUrl - Custom URL for home button
 * @returns {JSX.Element}
 */
function NotFound({ 
  title, 
  heading, 
  message, 
  showHomeButton = false,
  homeButtonText,
  homeButtonUrl = '/'
}) {
  const { t } = useTranslation();
  
  // Use provided props or fall back to translations
  const pageTitle = title || t('not_found.title');
  const headingText = heading || t('not_found.page_not_found');
  const messageText = message || t('not_found.message');
  const buttonText = homeButtonText || t('Home');
  
  return (
    <div className={styles.notFoundContainer}>
      <Helmet>
        <title>FindCV - {pageTitle}</title>
      </Helmet>
      <div className={styles.notFoundContent}>
        <div className={styles.notFoundIcon}>404</div>
        <h2 className={styles.notFoundHeading}>{headingText}</h2>
        <p className={styles.notFoundMessage}>{messageText}</p>
        
        {showHomeButton && (
          <div className={styles.notFoundActions}>
            <Link to={homeButtonUrl} className={styles.homeButton}>
              {buttonText}
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}

export default NotFound; 